// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"99":"bambuser-handler","506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] || chunkId) + "." + {"99":"73fea1d8","280":"4e5f4aa3","506":"05ada323","536":"069d73c4","889":"e0f84aac"}[chunkId] + ".js";
};